/**
 * Shop popup: appears after data-delay ms, hidden for 7 days once closed.
 * The cookie is a UI preference only (no tracking).
 */
const COOKIE = 'shop-popup_closed';

const hasCookie = () => document.cookie.split( ';' ).some( ( c ) => c.trim().startsWith( `${ COOKIE }=` ) );

export function initPopup() {
	const popup = document.getElementById( 'popup-shop' );
	if ( ! popup || hasCookie() ) {
		return;
	}
	const delay = parseInt( popup.dataset.delay || '5000', 10 );
	setTimeout( () => popup.setAttribute( 'aria-hidden', 'false' ), delay );

	popup.querySelector( '.close-button' )?.addEventListener( 'click', () => {
		popup.setAttribute( 'aria-hidden', 'true' );
		const expires = new Date( Date.now() + 7 * 864e5 ).toUTCString();
		document.cookie = `${ COOKIE }=1; expires=${ expires }; path=/; SameSite=Lax${ location.protocol === 'https:' ? '; Secure' : '' }`;
	} );
}
